import React, { useState } from 'react';
import './CeCalculator.css'
import Axios from 'axios';
import { useAuth } from "../Context/AuthContext";

const CaloricExpenditureCalculator = () => {
  const [duration, setDuration] = useState('');
  const [metValue, setMetValue] = useState('');
  const [weight, setWeight] = useState('');
  const [caloriesBurned, setCaloriesBurned] = useState(null);
  const [resstyle, setresstyle] = useState('none');
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  
  const calculateCalories = async () => {
    if (!duration || !metValue || !weight) {
      alert('Please enter valid values for all fields.');
      return;
    }
    const calories = parseFloat(duration) * parseFloat(metValue) * parseFloat(weight);
    setCaloriesBurned(calories.toFixed(2));
    try{
      const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/saveftdata',{'userEmail':appUser.email,'toolName':'BurnedCalories','toolValue':calories.toFixed(2)});
      console.log(response);
    }catch(error){
      console.log(error);
    }
    setresstyle('flex');
  };

  return (
    <div className="caloric-expenditure-container">
      <h2>Caloric Expenditure Calculator</h2>

      <div className="input-container">
        <label htmlFor="duration">Duration (hours):</label>
        <input
          type="number"
          id="duration"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />
      </div>

      <div className="input-container">
        <label htmlFor="metValue">MET Value:</label>
        <input
          type="number"
          id="metValue"
          value={metValue}
          onChange={(e) => setMetValue(e.target.value)}
        />
      </div>

      <div className="input-container">
        <label htmlFor="weight">Weight (kg):</label>
        <input
          type="number"
          id="weight"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />
      </div>

      <button className="calculate-btn" onClick={calculateCalories}>
        Calculate Calories
      </button>

      {caloriesBurned !== null && (
        <div id='result-container' className="result" style={{display:{resstyle}}}>
          <p>Calories Burned: {caloriesBurned} calories</p>
        </div>
      )}
    </div>
  );
};

export default CaloricExpenditureCalculator;
